/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

import _ from 'lodash';
import validationTypeDeclaration from '../validationTypeDeclaration';

const validationStep1 = (selectedDeclarationType: string | null) => (_.pickBy({
  validationTypeDeclaration: validationTypeDeclaration(selectedDeclarationType),
}, (v) => !_.isNil(v) && !_.isEmpty(v)));

export default validationStep1;
